(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["giacomini-strainer-landing-2"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.__gcmInitLanding2) return;
    root.__gcmInitLanding2 = true;

    // ---- Variant selection ----
    var idField = root.querySelector('[data-gcm-id]');
    var priceEl = root.querySelector('[data-gcm-price]');
    var compareEl = root.querySelector('[data-gcm-compare]');
    var stickyPrice = root.querySelector('[data-gcm-sticky-price]');
    var radios = root.querySelectorAll('[data-gcm-variant]');

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (idField) idField.value = r.value;
        if (priceEl && r.dataset.price) priceEl.textContent = r.dataset.price;
        if (compareEl) compareEl.textContent = r.dataset.compare || '';
        if (stickyPrice && r.dataset.price) stickyPrice.textContent = r.dataset.price;
        root.querySelectorAll('.gcm-variant').forEach(function (l) { l.classList.remove('is-active'); });
        var lab = r.closest('.gcm-variant');
        if (lab) lab.classList.add('is-active');
      });
    });

    // ---- Quantity stepper ----
    var qtyIn = root.querySelector('[data-gcm-qtyin]');
    root.querySelectorAll('[data-gcm-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyIn) return;
        var val = parseInt(qtyIn.value, 10) || 1;
        val += parseInt(b.dataset.gcmQty, 10);
        if (val < 1) val = 1;
        qtyIn.value = val;
      });
    });

    // ---- Sticky bar: show after hero scrolled past, hide near buy box & footer ----
    var sticky = root.querySelector('[data-gcm-sticky]');
    var buy = root.querySelector('[id^="gcm-buy-"]');
    if (sticky) {
      var onScroll = function () {
        var y = window.scrollY || window.pageYOffset;
        var show = y > 480;
        if (buy) {
          var r = buy.getBoundingClientRect();
          // hide while the buy box itself is on screen
          if (r.top < window.innerHeight && r.bottom > 0) show = false;
        }
        sticky.hidden = !show;
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  function boot() { document.querySelectorAll('[data-gcm-root]').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  // Shopify theme editor: re-init when section is reloaded
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-gcm-root]');
    if (r) { r.__gcmInitLanding2 = false; init(r); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giacomini-strainer-landing"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.__gcmInitBulk) return;
    root.__gcmInitBulk = true;
    
    // ---- Bulk order modal ----
    var modal = root.querySelector('.gcm-modal');
    if (modal) {
      var openBtns = document.querySelectorAll('[data-gcm-bulk-order-open]');
      var closeBtns = modal.querySelectorAll('[data-gcm-bulk-order-close]');
      var formWrap = modal.querySelector('[data-gcm-bulk-order-form-wrap]');
      var successWrap = modal.querySelector('[data-gcm-bulk-order-success]');
      var bulkForm = modal.querySelector('form');

      var openModal = function () {
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      };
      var closeModal = function () {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      };

      openBtns.forEach(function (b) { b.addEventListener('click', openModal); });
      closeBtns.forEach(function (b) { b.addEventListener('click', closeModal); });

      var okBtn = modal.querySelector('[data-gcm-bulk-order-ok]');
      if (okBtn) {
        okBtn.addEventListener('click', closeModal);
      }

      if (bulkForm) {
        var targetIframe = modal.querySelector('iframe');

        if (targetIframe) {
          bulkForm.setAttribute('target', targetIframe.getAttribute('name'));

          var submitted = false;
          bulkForm.addEventListener('submit', function () {
            submitted = true;

            function getVal(name) {
              var el = bulkForm.querySelector('[name="' + name + '"]');
              return el ? el.value : '';
            }

            var sheetData = {
              name: getVal('contact[Name]'),
              phone: getVal('contact[Phone]'),
              city: getVal('contact[City]'),
              quantity: getVal('contact[Quantity]'),
              role: getVal('contact[Role]')
            };

            fetch('https://script.google.com/macros/s/AKfycbyEUzRTre-T6xSJMPP6IE7zoz7mJ-AAeUBe7FKQktT6s7qUBjcb1G7TPUAg-LmxFaWJLw/exec', {
              method: 'POST',
              mode: 'no-cors',
              body: JSON.stringify(sheetData)
            }).catch(function () {});
          });

          targetIframe.addEventListener('load', function () {
            if (!submitted) return;
            formWrap.hidden = true;
            successWrap.hidden = false;
          });
        }
      }
    }

    // ---- Variant selection ----
    var idField = root.querySelector('[data-gcm-id]');
    var priceEl = root.querySelector('[data-gcm-price]');
    var compareEl = root.querySelector('[data-gcm-compare]');
    var stickyPrice = root.querySelector('[data-gcm-sticky-price]');
    var radios = root.querySelectorAll('[data-gcm-variant]');

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (idField) idField.value = r.value;
        if (priceEl && r.dataset.price) priceEl.textContent = r.dataset.price;
        if (compareEl) compareEl.textContent = r.dataset.compare || '';
        if (stickyPrice && r.dataset.price) stickyPrice.textContent = r.dataset.price;
        root.querySelectorAll('.gcm-variant').forEach(function (l) { l.classList.remove('is-active'); });
        var lab = r.closest('.gcm-variant');
        if (lab) lab.classList.add('is-active');
      });
    });

    // ---- Quantity stepper ----
    var qtyIn = root.querySelector('[data-gcm-qtyin]');
    root.querySelectorAll('[data-gcm-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyIn) return;
        var val = parseInt(qtyIn.value, 10) || 1;
        val += parseInt(b.dataset.gcmQty, 10);
        if (val < 1) val = 1;
        qtyIn.value = val;
      });
    });

    // ---- Sticky bar: show after hero scrolled past, hide near buy box & footer ----
    var sticky = root.querySelector('[data-gcm-sticky]');
    var buy = root.querySelector('[id^="gcm-buy-"]');
    if (sticky) {
      var onScroll = function () {
        var y = window.scrollY || window.pageYOffset;
        var show = y > 480;
        if (buy) {
          var r = buy.getBoundingClientRect();
          // hide while the buy box itself is on screen
          if (r.top < window.innerHeight && r.bottom > 0) show = false;
        }
        sticky.hidden = !show;
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  function boot() { document.querySelectorAll('[data-gcm-root]').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  // Shopify theme editor: re-init when section is reloaded
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-gcm-root]');
    if (r) { r.__gcmInitBulk = false; init(r); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
